import { render, staticRenderFns } from "./newest_video.vue?vue&type=template&id=bfc39c28"
import script from "./newest_video.vue?vue&type=script&lang=js"
export * from "./newest_video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports